// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"796":"67da1b1d","907":"67da1b1d","2157":"67da1b1d"}[chunkId] + ".chunk.css";
};